import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppService } from '../../../services/app.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BcContestService } from '../../../services/bc-contest.service';
import { ICourseCard, bcState } from '../shared';
import { IBcContestEvent } from '../../../models/BcContest';
import { BcContestEventsComponent, View } from '../events/bc-contest-events.component';

const eventCache: { [groupId: string]: IBcContestEvent[] } = { };

@Component({
    selector: 'app-bc-contest-course-card',
    templateUrl: './bc-contest-course-card.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestCourseCardComponent {
    constructor(
        public app: AppService,
        private service: BcContestService,
        private modal: NgbModal
    ) { }

    @Input() course: ICourseCard;
    @Input() studentId: number;
    @Input() warning: string;
    @Input() disabled: boolean;

    @Output('remove') removeEvent = new EventEmitter<ICourseCard>();
    @Output('add') addEvent = new EventEmitter<ICourseCard>();

    get isReadOnly() {
        return !bcState.getActiveContest()?.IsOpened;
    }

    add(course: ICourseCard) {
        const groupId = course.selectedGroupId || course.GroupId;

        this.app.addLoading(this.service.addApplication(this.studentId, course.SubjectSemesterId, groupId)).subscribe(data => {
            course.ApplicationId = data.Id;
            course.ApplicationCount = data.ApplicationCount;
            course.Probability = data.Probability;

            this.addEvent.emit(course);
        });
    }

    remove(course: ICourseCard) {
        this.app.addLoading(this.service.removeApplication(course.ApplicationId)).subscribe(data => {
            course.ApplicationId = undefined;
            course.ApplicationCount = data.ApplicationCount;
            course.Probability = undefined;

            this.removeEvent.emit(course);
        });
    }

    onGroupChange(event, course: ICourseCard, group: ICourseCard) {
        course.selectedGroupId = event == true ? group.GroupId : undefined;
    }

    openEvents(course: ICourseCard, group: ICourseCard, view: View) {
        const show = (events: IBcContestEvent[]) => {
            const ref = this.modal.open(BcContestEventsComponent);

            ref.componentInstance.data = {
                events,
                info: course.Info,
                view
            };
        };

        let cached = eventCache[group.GroupId];

        if (cached) {
            show(eventCache[group.GroupId]);
        } else {
            if (group.GroupId) {
                this.app.addLoading(this.service.getGroupEvents(group.GroupId)).subscribe(events => {
                    eventCache[group.GroupId] = events;
                    show(events);
                });
            } else {
                show([<IBcContestEvent>{
                    Address: group.Location,
                    DateTime: this.getCourseDateTimeString(course, group)
                }]);
            }
        }
    }

    getCourseDateTimeString(course: ICourseCard, group: ICourseCard): string {
        if (course.HasDetailedPlanning) {
            return this.app.translate('bcContestApply_calendar');
        }

        if (group.GroupDay && group.TimeFrom && group.TimeTo) {
            return `${group.GroupDay}, ${group.TimeFrom} - ${group.TimeTo}`;
        }

        if (group.GroupDay && !group.TimeFrom && !group.TimeTo) {
            return group.GroupDay;
        }

        if (!group.GroupDay && !group.TimeFrom && !group.TimeTo) {
            return this.app.translate('bcContestApply_toBeSpecified');
        }

        return '';
    }
}
